import { queryOptions } from '@tanstack/react-query'

import { fetchPartnerDetail } from '../api'
import { partnersQueryKeys } from '../query-keys'

export const getPartnerDetailQueryOptions = (param: {
  tenantKey: string
  partnerId: number
}) =>
  queryOptions({
    queryKey: partnersQueryKeys.detail(param.tenantKey, param.partnerId),
    queryFn: async () => fetchPartnerDetail(param)
  })
